import { render, staticRenderFns } from "./footer1.vue?vue&type=template&id=253efd5e&scoped=true"
import script from "./footer1.vue?vue&type=script&lang=js"
export * from "./footer1.vue?vue&type=script&lang=js"
import style0 from "./footer1.vue?vue&type=style&index=0&id=253efd5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253efd5e",
  null
  
)

export default component.exports